import React from 'react';

const PreSkillIcon: React.FC = () => {
  return (
    <>
      <div className="tw-relative tw-w-8 tw-h-8">
        {/* Default SVG */}
        <div className="tw-absolute tw-inset-0 tw-transition-opacity tw-duration-300 tw-opacity-100 support-icon-normal">
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 7.8C3 5.53726 3 4.40589 3.70294 3.70294C4.40589 3 5.53726 3 7.8 3H10.2C12.4627 3 13.5941 3 14.2971 3.70294C15 4.40589 15 5.53726 15 7.8V10.2C15 12.4627 15 13.5941 14.2971 14.2971C13.5941 15 12.4627 15 10.2 15H7.8C5.53726 15 4.40589 15 3.70294 14.2971C3 13.5941 3 12.4627 3 10.2V7.8Z"
              fill="#02C386"
            />
            <path
              d="M17 7.8C17 5.53726 17 4.40589 17.7029 3.70294C18.4059 3 19.5373 3 21.8 3H24.2C26.4627 3 27.5941 3 28.2971 3.70294C29 4.40589 29 5.53726 29 7.8V10.2C29 12.4627 29 13.5941 28.2971 14.2971C27.5941 15 26.4627 15 24.2 15H21.8C19.5373 15 18.4059 15 17.7029 14.2971C17 13.5941 17 12.4627 17 10.2V7.8Z"
              fill="#0A9AF8"
            />
            <path
              d="M3 21.8C3 19.5373 3 18.4059 3.70294 17.7029C4.40589 17 5.53726 17 7.8 17H10.2C12.4627 17 13.5941 17 14.2971 17.7029C15 18.4059 15 19.5373 15 21.8V24.2C15 26.4627 15 27.5941 14.2971 28.2971C13.5941 29 12.4627 29 10.2 29H7.8C5.53726 29 4.40589 29 3.70294 28.2971C3 27.5941 3 26.4627 3 24.2V21.8Z"
              fill="#FDB814"
            />
            <path
              d="M17 21.8C17 19.5373 17 18.4059 17.7029 17.7029C18.4059 17 19.5373 17 21.8 17H24.2C26.4627 17 27.5941 17 28.2971 17.7029C29 18.4059 29 19.5373 29 21.8V24.2C29 26.4627 29 27.5941 28.2971 28.2971C27.5941 29 26.4627 29 24.2 29H21.8C19.5373 29 18.4059 29 17.7029 28.2971C17 27.5941 17 26.4627 17 24.2V21.8Z"
              fill="#A6A6A6"
            />
          </svg>
        </div>

        {/* Hover SVG */}
        <div className="tw-absolute tw-inset-0 tw-transition-opacity tw-duration-300 tw-opacity-0 support-icon-hover">
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 7.8C3 5.53726 3 4.40589 3.70294 3.70294C4.40589 3 5.53726 3 7.8 3H10.2C12.4627 3 13.5941 3 14.2971 3.70294C15 4.40589 15 5.53726 15 7.8V10.2C15 12.4627 15 13.5941 14.2971 14.2971C13.5941 15 12.4627 15 10.2 15H7.8C5.53726 15 4.40589 15 3.70294 14.2971C3 13.5941 3 12.4627 3 10.2V7.8Z"
              fill="#02C386"
            />
            <path
              d="M17.2423 7.7424C16.6567 5.55676 16.3639 4.46394 16.8609 3.60301C17.358 2.74209 18.4508 2.44927 20.6364 1.86363L22.9547 1.24246C25.1403 0.656819 26.2331 0.363999 27.0941 0.861055C27.955 1.35811 28.2478 2.45093 28.8334 4.63657L29.4546 6.95479C30.0402 9.14044 30.3331 10.2333 29.836 11.0942C29.339 11.9551 28.2461 12.2479 26.0605 12.8336L23.7423 13.4547C21.5566 14.0404 20.4638 14.3332 19.6029 13.8361C18.742 13.3391 18.4491 12.2463 17.8635 10.0606L17.2423 7.7424Z"
              fill="#0A9AF8"
            />
            <path
              d="M3 21.8C3 19.5373 3 18.4059 3.70294 17.7029C4.40589 17 5.53726 17 7.8 17H10.2C12.4627 17 13.5941 17 14.2971 17.7029C15 18.4059 15 19.5373 15 21.8V24.2C15 26.4627 15 27.5941 14.2971 28.2971C13.5941 29 12.4627 29 10.2 29H7.8C5.53726 29 4.40589 29 3.70294 28.2971C3 27.5941 3 26.4627 3 24.2V21.8Z"
              fill="#FDB814"
            />
            <path
              d="M17 21.8C17 19.5373 17 18.4059 17.7029 17.7029C18.4059 17 19.5373 17 21.8 17H24.2C26.4627 17 27.5941 17 28.2971 17.7029C29 18.4059 29 19.5373 29 21.8V24.2C29 26.4627 29 27.5941 28.2971 28.2971C27.5941 29 26.4627 29 24.2 29H21.8C19.5373 29 18.4059 29 17.7029 28.2971C17 27.5941 17 26.4627 17 24.2V21.8Z"
              fill="#A6A6A6"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default PreSkillIcon;
